<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <base-material-card color="primary" icon="mdi-label-multiple-outline " inline class="px-5 py-3">
          <template v-slot:after-heading>
            <div class="display-1 font-weight-light">
              {{ title }}
            </div>
          </template>
          <v-form class="pt-5">
            <v-row align="center" no-gutters class="ml-0">
              <v-text-field v-model="nome" label="Nome" outlined class="ml-4 mr-4" prepend-icon="" />
            </v-row>
            <v-row align="center" no-gutters class="ml-3 mt-n2">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <v-checkbox
                      v-model="categoria_privada"
                      class="mt-0"
                      prepend-icon="mdi-account-cog"
                      label="Categoria Privada"
                    />
                  </div>
                </template>
                <span>Categorias privadas só podem ser visualizadas por administradores</span>
              </v-tooltip>
            </v-row>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6" />
      <v-col cols="12" md="6">
        <v-btn color="green" min-width="100" style="float: right" class="mt-n5" :loading="loading" @click="salvar()">
          Salvar
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import CategoriasService from '@/services/CategoriasService';

  export default {
    data: () => ({
      nome: '',
      categoria_privada: false,
      loading: false
    }),

    computed: {
      title() {
        return this.$route.params.id ? 'Editando Categoria' : 'Adicionar Nova Categoria';
      }
    },

    mounted() {
      if (this.$route.params.id) this.getById(this.$route.params.id);
    },

    methods: {
      getById(id) {
        CategoriasService.getById(id)
          .then((response) => {
            let rData = response.data.data;
            this.nome = rData.nome;
            this.categoria_privada = rData.categoria_privada;
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao recuperar as categorias.', '', { position: 'topRight' });
          });
      },
      salvar() {
        this.loading = true;
        const data = {
          id: this.$route.params.id ? this.$route.params.id : null,
          nome: this.nome,
          categoria_privada: this.categoria_privada
        };

        CategoriasService.salvar(data)
          .then(() => {
            this.$toast.success('Categoria salva com sucesso.', '', { position: 'topRight' });
            this.$router.push({ name: 'Categorias' });
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao salvar categoria.', '', { position: 'topRight' });
          })
          .finally(() => (this.loading = false));
      }
    }
  };
</script>
